import React from 'react';
import moment from 'moment';

import customClientConfig from '../../customClientConfig';

const FooterComponent = ({ company, tenant }) => {
  const getCompanyName = () => {
    const clientConfig = customClientConfig[tenant];
    if (clientConfig && clientConfig.clientName) {
      return clientConfig.clientName;
    }

    switch (company) {
      case 'hlx':
        return 'HealthLogiX, LLC';
      case 'mei':
        return 'MEI';
      case 'scimed':
        return 'SciMed';
      default:
        return 'HealthLogiX, LLC';
    }
  };

  return (
    <div className="footer">
      <span>
        Copyright {moment().format('YYYY')} &copy; {getCompanyName()}.
      </span>
      &nbsp;All Rights Reserved.
    </div>
  );
};

export default FooterComponent;
